import { useState } from 'react'

import { IRegex } from '../../../../stores/lookUpStore'
import EditRegex from '../EditRegex/EditRegex'
import RegexContent from '../RegexContent/RegexContent'

interface IRegexProps {
    regex: IRegex
}

function Regex(props: IRegexProps) {
    const { regex } = props

    const [isEditing, setIsEditing] = useState(false)

    return isEditing ? (
        <EditRegex regex={regex} setIsEditing={setIsEditing} />
    ) : (
        <RegexContent regex={regex} setIsEditing={setIsEditing} />
    )
}

export default Regex
